// Company list service: HTTP operations for listing companies

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_ListCompaniesOut,
  CompanyListParams,
  CompaniesPage,
} from '../types/companyList.types';
import { mapCompanyPagedResultToModel } from '../mappers/companyList.mapper';

/**
 * Company list service
 */
export class CompanyListService {
  /**
   * List companies with pagination, search and sort
   */
  async list(params: CompanyListParams, signal?: AbortSignal): Promise<ApiResponse<CompaniesPage>> {
    const queryString = buildQueryString({
      page: params.page,
      pageSize: params.pageSize,
      searchText: params.searchText,
      orderBy: params.sort?.key,
      orderDirection: params.sort?.direction?.toUpperCase(),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.COMPANY.LIST}${queryString}`;

    // Call API with GET
    const response = await apiClient.get<LC_ListCompaniesOut>(endpoint, { signal });

    // Map response if successful
    // Note: response.data already contains { data: [...], pagination: {...} } after envelope unwrap
    if (response.success && response.data) {
      const mappedData = mapCompanyPagedResultToModel(response.data);
      return {
        success: true,
        data: mappedData,
      };
    }

    return {
      success: false,
      data: null,
      error: response.error,
    };
  }
}

export const companyListService = new CompanyListService();
